export default __webpack_public_path__ + "static/media/VIII_Old_White.083f5553.png";